/**
 * Global route middleware that persists TWA query parameters to sessionStorage.
 *
 * When the Android TWA launches, it appends device info as query params
 * (e.g. _twa_version, _twa_build, _twa_model). These params can be lost
 * when mh-middleware redirects unauthenticated users to the login page
 * with { external: true } (full page reload).
 *
 * This middleware runs before any route middleware, captures the params
 * into sessionStorage, and the app-device-info plugin reads them back.
 */
const TWA_PARAM_KEYS = ['_twa_version', '_twa_build', '_twa_model', '_twa_os', '_twa_manufacturer', '_twa_push_permission'] as const

export default defineNuxtRouteMiddleware(to => {
  if (import.meta.server) return

  const query = to.query
  for (const key of TWA_PARAM_KEYS) {
    const value = query[key]
    if (typeof value === 'string' && value) {
      sessionStorage.setItem(key, value)
    }
  }
})
